var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.dataFetched)?_c('div',{staticClass:"col-md-6",staticStyle:{"margin":"0 auto"}},[(!_vm.allowed)?_c('v-alert',{attrs:{"dense":"","type":"error"}},[_vm._v("Vous n'avez pas accès a ce projet")]):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }